import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useHistory } from 'react-router-dom';
import Slider from 'react-slick';
import { Grid, Text } from 'elements';
import { getCaseSeason, getCaseList } from 'libs/api/case';
import { TRequestCaseList, TSeason, TCase } from 'modules/case/types';
import { CWindowWidth } from 'constants/base.const';
import { Button, Select, Tag, Pagination, Spin } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { Colors, LightGrayColor } from 'GlobalStyles';
import MainBackImage from 'assets/images/banners/4.webp';

const Board = () => {
  const history = useHistory();
  const limit = 6;

  const [isPaid, setIsPaid] = useState(false);
  const [page, setPage] = useState<number>(1);
  const [total, setTotal] = useState<number>(1);
  const [selectedOrder, setSelectedOrder] = useState('numbering');
  const [seasons, setSeasons] = useState<Array<TSeason>>();
  const [selectedSeason, setSelectedSeason] = useState<string>('');
  const [cases, setCases] = useState<Array<TCase>>();

  const getSeason = async () => {
    const { success, data } = await getCaseSeason();
    if (success && data.length > 0) {
      setSelectedSeason(data[0].version);
      setSeasons(data);
    }
  };

  const getList = async () => {
    const params: TRequestCaseList = {
      current: page,
      pageSize: limit,
      season: selectedSeason,
      is_payed: isPaid ? 'True' : 'False',
    };
    if (selectedOrder === 'numbering') params.numbering = 'numbering';
    else if (selectedOrder === 'difficulty') params.difficulty = 'difficulty';
    else if (selectedOrder === 'is_good') params.is_good = 'is_good';
    else if (selectedOrder === 'views') params.views = 'views';
    const { success, data } = await getCaseList(params);
    if (success) {
      setTotal(data.total);
      setCases(data.contents);
    }
  };

  useEffect(() => {
    if (selectedSeason) getList();
  }, [selectedSeason, selectedOrder, isPaid, page]);

  useEffect(() => {
    getSeason();
  }, []);

  return (
    <>
      <Helmet>
        <title>케이스 노트</title>
      </Helmet>

      <Grid image={MainBackImage} height='400px' md={{ height: '100px' }}>
        <Grid height='100%' backgroundColor={`${Colors.black}33`} justify='center'>
          <Grid width={`${CWindowWidth}px`} padding='0 7%' align='center'>
            <Grid>
              <Text color={Colors.white} size='4rem' bold md={{ size: '2rem' }}>
                케이스 노트
              </Text>
            </Grid>
            <Grid marginTop='5px'>
              <Text color={Colors.white} size='1.1rem' md={{ size: '0.9rem' }}>
                Career Step이 직접 제작한 self-study 용 Case 자료입니다.
              </Text>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      {/* <Grid
        isNoWrap
        justify="center"
        gap="20px"
        padding="20px"
        sm={{ display: 'none' }}
        style={{ borderBottom: `1px solid ${LightGrayColor}` }}
      >
        {!!seasons &&
          seasons.map(s => (
            <Button
              key={s.id}
              type="text"
              style={{ fontSize: '1.3rem', width: 180 }}
              className={
                'btn-text' +
                `${selectedSeason !== s.version ? ' disabled' : ''}`
              }
              onClick={() => setSelectedSeason(s.version)}
            >
              {s.title} 시즌
            </Button>
          ))}
      </Grid>
      <Grid display="none" padding="20px 0" sm={{ display: 'block' }}>
        {!!seasons && (
          <Slider
            dots={false}
            infinite={true}
            arrows
            beforeChange={index => setSelectedSeason(seasons[index].version)}
            nextArrow={<Button type="text" icon={<RightOutlined />} />}
            prevArrow={<Button type="text" icon={<LeftOutlined />} />}
          >
            {seasons.map(s => (
              // <div><Grid key={s.id} justify='center'><Text size='1.3rem'>{s.title} {s.version}</Text></Grid></div>
              <div>
                <Grid key={s.id} justify="center">
                  <Text size="1.3rem">{s.title} 시즌</Text>
                </Grid>
              </div>
            ))}
          </Slider>
        )}
      </Grid> */}

      <Grid margin='40px 0 150px 0'>
        <Grid width={`${CWindowWidth}px`} margin='0 auto' padding='0 20px'>
          <Grid justify='space-between' align='flex-end'>
            <Text bold size='2rem'>
              {/* 2021년 하반기 Case */}
            </Text>
            <Grid isInline gap='15px' sm={{ marginTop: '10px' }}>
              <Button onClick={() => setIsPaid(!isPaid)}>{isPaid ? '전체' : '구매한'} Case만 보기</Button>
              <Select value={selectedOrder} onChange={setSelectedOrder}>
                <Select.Option value={'numbering'}>번호순</Select.Option>
                <Select.Option value={'difficulty'}>난이도순</Select.Option>
                <Select.Option value={'is_good'}>추천순</Select.Option>
                <Select.Option value={'views'}>조회순</Select.Option>
              </Select>
            </Grid>
          </Grid>

          <Grid
            align='flex-start'
            marginTop='40px'
            gap='2%'
            md={{ gap: '4%' }}
            sm={{ gap: '0', marginTop: '10px' }}
          >
            {!cases ? (
              <Grid justify='center' align='center' height='100px'>
                <Spin spinning />
              </Grid>
            ) : cases.length === 0 ? (
              <Grid justify='center' align='center' height='100px'>
                <Text size='1.2rem'>데이터가 없습니다.</Text>
              </Grid>
            ) : (
              cases.map((c) => (
                <Grid
                  key={c.id}
                  width='32%'
                  height='335px'
                  align='flex-start'
                  border={`1px solid ${Colors.grey1}`}
                  cursor='pointer'
                  md={{ width: '48%' }}
                  sm={{ width: '100%', marginTop: '25px' }}
                  onClick={() => history.push(`/case/board/${c.id}`)}
                >
                  <Grid
                    image={c.thumbnail_images}
                    height='185px'
                    justify='flex-end'
                    position='relative'
                    overflow='hidden'
                  >
                    {!!c.is_payed && (
                      <>
                        <Grid
                          isInline
                          position='absolute'
                          width='100px'
                          height='100px'
                          backgroundColor='#B1DFB3'
                          style={{
                            transform: 'rotate(45deg)',
                            right: -50,
                            top: -50,
                          }}
                        />
                        <Grid isInline position='absolute' style={{ right: 5, top: 5 }}>
                          <Text color={Colors.white} bold>
                            구매됨
                          </Text>
                        </Grid>
                      </>
                    )}
                  </Grid>
                  <Grid height='calc(100% - 185px)' align='space-between' padding='8px 16px 16px 16px'>
                    <Grid>
                      <Grid>
                        <Text>{c.title}</Text>
                      </Grid>
                      {!!c.question_tag && c.question_tag.length > 0 && (
                        <Grid gap='5px' marginTop='8px'>
                          {c.question_tag.map((t) => (
                            // <Tag key={t}>{t}</Tag>
                            <Button
                              className='small'
                              style={{
                                minHeight: '22px',
                                marginRight: '5px',
                                fontSize: '1rem',
                              }}
                              key={t}
                            >
                              {' '}
                              {t}{' '}
                            </Button>
                          ))}
                        </Grid>
                      )}
                    </Grid>
                    <Grid marginTop='8px' justify='space-between'>
                      <Grid gap='5px' isInline>
                        <Text>조회수 {c.hit_count}</Text>
                        <Text>추천 {c.is_good}</Text>
                      </Grid>
                      <Text>난이도 {c.difficulty} / 5.0</Text>
                    </Grid>
                  </Grid>
                </Grid>
              ))
            )}
          </Grid>

          <Grid marginTop='40px' justify='center'>
            <Pagination current={page} pageSize={limit} responsive total={total} onChange={setPage} />
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default Board;
